import { css } from 'jimu-core';
export const listGroupStyles = (props) => {
    const isFlush = props.flush;
    return css `
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;

    ${isFlush && css `
      .list-group-item {
        border-right: 0;
        border-left: 0;
        border-radius: 0;
      }

      &:first-of-type {
        .list-group-item:first-of-type {
          border-top: 0;
        }
      }

      &:last-of-type {
        .list-group-item:last-of-type {
          border-bottom: 0;
        }
      }
    `}

  `;
};
